import { default as AbstractModal } from './_AbstractModal'
import { CSS_CLASS, API_ENDPOINTS, MODAL_CONTENT_KEYS } from '../config'

export default class ModalContent extends AbstractModal {

    constructor(m) {
        super(m)

        // DOM
        this.$content = this.$('content')[0]
    }

    onOpen({ type, id }) {
        type = MODAL_CONTENT_KEYS[type.toUpperCase()]

        if(typeof type === 'undefined') {
            this.close()
            return
        }

        fetch(`${API_ENDPOINTS.MODALS[type]}/${id}`)
            .then(r => r.text())
            .then(data => {
                this.$content.innerHTML = data
                this.$el.classList.add(CSS_CLASS.LOADED)
            })
            .catch(e => {
                this.close()
            })
    }

    onClose() {
        setTimeout(() => {
            this.$content.innerHTML = ''
            this.$el.classList.remove(CSS_CLASS.LOADED)
            this.call('onModalClose', null, 'Schedule')
            this.call('onModalClose', null, 'AthletesList')
        }, 250)
    }
}
